import React, {forwardRef, memo} from 'react';

import {TeammateModel} from '../../../../../libs/shared/core/src/models/api/teammateModel';
import {buildTeammateDisplayName} from '../../../../../libs/shared/core/src/models/helpers/teammateModelHelpers';
import {TokenBase, TokenBaseProps} from './tokenBase';

/*
 * Props.
 */

export interface TeammateTokenProps extends TokenBaseProps {
  teammate: TeammateModel;
}

/*
 * Component.
 */

export const TeammateToken = memo(
  forwardRef<HTMLDivElement, TeammateTokenProps>((props, ref) => (
    <TokenBase {...props} ref={ref}>
      {buildTeammateDisplayName(props.teammate)}
    </TokenBase>
  )),
);
